import { Flex } from 'foundations-components/components/Flex';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useSelector } from 'react-redux';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingMerchCardCTAs = ({
  use = 'primary',
  purchaseMotions
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);

  // show 2 loading buttons for app auth, 1 for public as fallback
  const loadingCountFallback = isAppAuth ? 2 : 1;
  const loadingButtonCount = (purchaseMotions === null || purchaseMotions === void 0 ? void 0 : purchaseMotions.length) || loadingCountFallback;
  const loadingButtons = Array.from({
    length: loadingButtonCount
  }, (_, i) => /*#__PURE__*/_jsx(LoadingButton, {
    block: true,
    loading: true,
    margin: "0",
    use: use || 'primary',
    children: "Loading"
  }, i));
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "200",
    inlineSize: "100%",
    children: loadingButtons
  });
};
export default LoadingMerchCardCTAs;